import React, { Component, useState, useContext } from "react";
import { Link, Redirect } from "react-router-dom";
import { Auth } from "aws-amplify";
import { notification, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import "./style.css";
import logo from "../../assets/img/nbrri-logo.png";
import { Context } from "../../Store.js";

function LoginPage() {
  const [state, dispatch] = useContext(Context);
  const [user, setUser] = useState({
    username: "",
    password: "",
  });

  const [redirect, setRedirect] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const signIn = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const { username, password } = user;
    try {
      const user = await Auth.signIn(username, password);
      if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
        Auth.completeNewPassword(user, password);
      }
      setIsLoading(false);
      dispatch({ type: "SET_LOGGED_IN_USER", payload: user });
      dispatch({ type: "SET_IS_LOGGED_IN", payload: true });
      notification.success({
        message: "Succesfully logged in!",
        description: "Successfully logged in, Redirecting you in a few!",
        placement: "topRight",
        duration: 2.0,
        onClose: () => {
          setRedirect("/search");
          setUser({ username: "", password: "" });
        },
      });
    } catch (error) {
      notification.error({
        message: "Error logging in!",
        description: error.message,
        placement: "topRight",
        duration: 1.0,
        onClose: () => {
          setRedirect(null);
          setIsLoading(false);
        },
      });
    }
  };
  if (redirect) {
    return <Redirect to={redirect} />;
  } else {
    return (
      <React.Fragment>
        <section className="h-100">
          <div className="container h-100">
            <div className="row justify-content-md-center h-100">
              <div className="card-wrapper">
                <div className="brand">
                  <img src={logo} alt="logo" />
                </div>
                <div className="card fat">
                  <div className="card-body">
                    <h4 className="card-title">Login</h4>
                    <form
                      method="POST"
                      className="my-login-validation"
                      onSubmit={signIn}
                      noValidate=""
                    >
                      <div className="form-group">
                        <label htmlFor="username">Username</label>
                        <input
                          id="username"
                          className="form-control"
                          onChange={(e) =>
                            setUser({ ...user, username: e.target.value })
                          }
                          value={user.username}
                          name="username"
                          required
                          autoFocus
                        />
                        <div className="invalid-feedback">Email is invalid</div>
                      </div>

                      <div className="form-group">
                        <label htmlFor="password">
                          Password
                          <a href="forgot.html" className="float-right">
                            Forgot Password?
                          </a>
                        </label>
                        <input
                          id="password"
                          type="password"
                          onChange={(e) =>
                            setUser({ ...user, password: e.target.value })
                          }
                          value={user.password}
                          className="form-control"
                          name="password"
                          required
                          data-eye
                        />
                        <div className="invalid-feedback">
                          Password is required
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="custom-checkbox custom-control"></div>
                      </div>

                      <div className="form-group m-0">
                        <button
                          type="submit"
                          className="btn btn-primary btn-block"
                        >
                          {isLoading ? (
                            <Spin
                              indicator={
                                <LoadingOutlined style={{ fontSize: 24 }} />
                              }
                            />
                          ) : (
                            "Login"
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="footer">&nbsp; &nbsp; </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default LoginPage;
